export const UPDATE_ROL_USER = `
    mutation assignPermisseToUser($permiseRequest: JSON ) {
      assignPermisseToUser  (permiseRequest: $permiseRequest) {
        message
        permissions {
          id
          name
        }
      }
    }
`;